<template>
    <div class="pcoded-main-container">
        <div class="pcoded-wrapper">
            <title>{{ $t("statistics.text_1") }} - DOFFERO®</title>
            <div class="pcoded-content pb-5" style="background-color: #f9f9f9; min-height: 100vh">
                <under-bar-name :title="$t('statistics.text_1')" :margin="true" />
                <div style="margin: 0 35px">
                    <div v-if="!load_admin_stats">
                        <div class="row p-0 mt-2">
                            <div class="col-lg-12 d-flex p-0 uzivatelia_mob">
                                <div v-if="free_count != null" class="col">
                                    <div class="dash_box free">
                                        <div>
                                            <h3>
                                                {{
                                                    formatNumber(
                                                        free_count
                                                    )
                                                }}
                                            </h3>
                                            <p>Zdarma</p>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="profi_count != null" class="col">
                                    <div class="dash_box profi">
                                        <div>
                                            <h3>
                                                {{
                                                    formatNumber(
                                                        profi_count
                                                    )
                                                }}
                                            </h3>
                                            <p>Profi</p>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="small_team_count != null" class="col">
                                    <div class="dash_box small_team">
                                        <div>
                                            <h3>
                                                {{
                                                    formatNumber(
                                                        small_team_count
                                                    )
                                                }}
                                            </h3>
                                            <p>Maly tim</p>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="large_team_count != null" class="col">
                                    <div class="dash_box large_team">
                                        <div>
                                            <h3>
                                                {{
                                                    formatNumber(
                                                        large_team_count
                                                    )
                                                }}
                                            </h3>
                                            <p>Veľký tím</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-12 d-flex p-0 uzivatelia_mob">
                                <div v-if="mojafirma_count != null" class="col">
                                    <div class="dash_box purple1">
                                        <div>
                                            <h3>
                                                {{
                                                    formatNumber(
                                                        mojafirma_count
                                                    )
                                                }}
                                            </h3>
                                            <p>{{ $t("dashboard.text_4") }}</p>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="polozky_ceny_count != null" class="col">
                                    <div class="dash_box purple2">
                                        <div>
                                            <h3>
                                                {{
                                                    formatNumber(
                                                        polozky_ceny_count
                                                    )
                                                }}
                                            </h3>
                                            <p>{{ $t("dashboard.text_5") }}</p>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="superfaktura_count != null" class="col">
                                    <div class="dash_box purple3">
                                        <div>
                                            <h3>
                                                {{
                                                    formatNumber(
                                                        superfaktura_count
                                                    )
                                                }}
                                            </h3>
                                            <p>{{ $t("dashboard.text_6") }}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-12 d-flex p-0 uzivatelia_mob">
                                <div v-if="count != null" class="col">
                                    <div class="dash_box blue1">
                                        <div>
                                            <h3>{{ formatNumber(count) }}</h3>
                                            <p>{{ $t("dashboard.text_12") }}</p>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="klient_count != null" class="col">
                                    <div class="dash_box blue2">
                                        <div>
                                            <h3>
                                                {{ formatNumber(klient_count) }}
                                            </h3>
                                            <p>{{ $t("dashboard.text_13") }}</p>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="avg_price != null" class="col">
                                    <div class="dash_box blue3">
                                        <div>
                                            <h3>
                                                {{ formatPrice(avg_price) }} €
                                            </h3>
                                            <p>{{ $t("dashboard.text_28") }}</p>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="offer_count_black != null" class="col">
                                    <div class="dash_box blue4">
                                        <div>
                                            <h3>
                                                {{
                                                    formatNumber(
                                                        offer_count_black
                                                    )
                                                }}
                                            </h3>
                                            <p>{{ $t("dashboard.text_14") }}</p>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="offer_count_white != null" class="col">
                                    <div class="dash_box blue5">
                                        <div>
                                            <h3>
                                                {{
                                                    formatNumber(
                                                        offer_count_white
                                                    )
                                                }}
                                            </h3>
                                            <p>{{ $t("dashboard.text_15") }}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="count != null" class="col-lg-12 d-flex p-0 uzivatelia_mob">
                                <div v-if="user_offer_info.without != null" class="col">
                                    <div class="dash_box colorP1">
                                        <div>
                                            <h3>
                                                {{
                                                    formatNumber(
                                                        user_offer_info.without
                                                    )
                                                }}
                                                <small>[{{
                                                    user_offer_info.without_percent
                                                }}%]</small>
                                            </h3>
                                            <p>{{ $t("dashboard.text_7") }}</p>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="user_offer_info.one != null" class="col">
                                    <div class="dash_box colorP2">
                                        <div>
                                            <h3>
                                                {{
                                                    formatNumber(
                                                        user_offer_info.one
                                                    )
                                                }}
                                                <small>[{{
                                                    user_offer_info.one_percent
                                                }}%]</small>
                                            </h3>
                                            <p>{{ $t("dashboard.text_8") }}</p>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="user_offer_info.two_five != null" class="col">
                                    <div class="dash_box colorP3">
                                        <div>
                                            <h3>
                                                {{
                                                    formatNumber(
                                                        user_offer_info.two_five
                                                    )
                                                }}
                                                <small>[{{
                                                    user_offer_info.two_five_percent
                                                }}%]</small>
                                            </h3>
                                            <p>{{ $t("dashboard.text_9") }}</p>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="user_offer_info.five_more != null" class="col">
                                    <div class="dash_box colorP4">
                                        <div>
                                            <h3>
                                                {{
                                                    formatNumber(
                                                        user_offer_info.five_more
                                                    )
                                                }}
                                                <small>[{{
                                                    user_offer_info.five_more_percent
                                                }}%]</small>
                                            </h3>
                                            <p>{{ $t("dashboard.text_10") }}</p>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="user_all != null" class="col">
                                    <div class="dash_box colorP5">
                                        <div>
                                            <h3>
                                                {{ formatNumber(user_all) }}
                                                <small>[100%]</small>
                                            </h3>
                                            <p>{{ $t("dashboard.text_11") }}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="graphs" style="align-items: baseline">
                            <div v-if="statistic.count_users_by_month != null" class="graph1">
                                <h2>{{ $t("dashboard.text_18") }}</h2>
                                <graph-users :data="statistic.count_users_by_month" />
                            </div>
                            <div v-if="statistic.count_offers_by_month != null" class="graph2">
                                <h2>{{ $t("dashboard.text_19") }}</h2>
                                <graph-offers :data="statistic.count_offers_by_month" />
                            </div>
                        </div>
                        <div class="graphs">
                            <div v-if="statistic.sent_emails" class="graph1">
                                <h2>{{ $t("dashboard.text_25") }}</h2>
                                <graph-emails :data="statistic.sent_emails" />
                            </div>
                            <div v-if="statistic.business_area != null" class="graph2">
                                <h2>{{ $t("dashboard.text_26") }}</h2>
                                <graph-business-area :data="statistic.business_area" />
                            </div>
                        </div>
                        <div class="graphs">
                            <div v-if="statistic.best_users != null" class="graph1">
                                <h2>{{ $t("dashboard.text_20") }}</h2>
                                <table-users :data="statistic.best_users" />
                            </div>
                            <div v-if="statistic.users_by_total_offer_price != null" class="graph2">
                                <h2>{{ $t("dashboard.text_29") }}</h2>
                                <table-users-price :data="statistic.users_by_total_offer_price" />
                            </div>
                        </div>
                        <div class="graphs">
                            <div v-if="statistic.users_by_avg_offer_price != null" class="graph1">
                                <h2>{{ $t("dashboard.text_30") }}</h2>
                                <table-users-avg-price :data="statistic.users_by_avg_offer_price" />
                            </div>
                        </div>
                    </div>
                    <div v-else class="loader_form">
                        <div class="container_loader">
                            <div class="holder_loader">
                                <div class="box_loader"></div>
                            </div>
                            <div class="holder_loader">
                                <div class="box_loader"></div>
                            </div>
                            <div class="holder_loader">
                                <div class="box_loader"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import UnderBarName from "../../../layouts/Header/UnderBarName.vue";
import GraphUsers from "./components/GraphUsers.vue";
import TableUsers from "./components/TableUsers.vue";
import TableUsersPrice from "./components/TableUsersPrice.vue";
import TableUsersAvgPrice from "./components/TableUsersAvgPrice.vue";
import GraphOffers from "./components/GraphOffers.vue";
import GraphEmails from "./components/GraphEmails.vue";
import GraphBusinessArea from "./components/GraphBusinessArea.vue";
export default {
    components: {
        UnderBarName,
        GraphUsers,
        TableUsers,
        TableUsersPrice,
        TableUsersAvgPrice,
        GraphOffers,
        GraphEmails,
        GraphBusinessArea,
    },
    data() {
        return {
            load_admin_stats: true,
            small_team_count: null,
            profi_count: null,
            large_team_count: null,
            free_count: null,
            mojafirma_count: null,
            polozky_ceny_count: null,
            superfaktura_count: null,
            offer_count_black: null,
            offer_count_white: null,
            klient_count: null,
            avg_price: null,
            count: null,
            user_all: null,
            user_offer_info: null,
            user_premium: null,
            user_free: null,
            statistic: {},
        };
    },
    created() {
        axios.post("/api/adminstats/adminInfov2").then((response) => {
            this.small_team_count = response.data.small_team;
            this.profi_count = response.data.profi;
            this.large_team_count = response.data.large_team;
            this.free_count = response.data.free;
            this.mojafirma_count = response.data.mojafirma_count;
            this.polozky_ceny_count = response.data.polozky_ceny_count;
            this.superfaktura_count = response.data.superfaktura_count;
        });
        axios.post("/api/adminstats/adminInfo").then((response) => {
            this.offer_count_black = response.data.offer_count_black;
            this.offer_count_white = response.data.offer_count_white;
            this.klient_count = response.data.klient_all_count;
            this.avg_price = response.data.avg_price;
            this.count = response.data.offer_all_count;
            this.user_all = response.data.user_all;
            this.user_offer_info = response.data.user_offer_info;
            this.user_premium = response.data.user_premium;
            this.user_free = response.data.user_free;
            this.statistic.count_users_by_month =
                response.data.count_users_by_month;
            this.statistic.count_offers_by_month =
                response.data.count_offers_by_month;
            this.statistic.best_users = response.data.best_users;
            this.statistic.users_by_avg_offer_price =
                response.data.users_by_avg_offer_price;
            this.statistic.users_by_total_offer_price =
                response.data.users_by_total_offer_price;
            this.statistic.sent_emails = response.data.sent_emails;
            this.statistic.business_area = response.data.business_area;
            this.load_admin_stats = false;
        });
    },
    methods: {
        formatPrice(value) {
            let val = (value / 1).toFixed(2).replace(".", ",");
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
        },
        formatNumber(value) {
            return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
        },
    },
};
</script>

<style lang="scss">
.graph1,
.graph2 {
    canvas {
        background-color: #fff;
        padding: 10px;
        border-radius: 6px;
    }
}
</style>

<style lang="scss" scoped>
.graphs {
    width: 100%;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;

    .graph1,
    .graph2 {
        width: 48%;
        margin-top: 30px;

        h2 {
            font-style: normal;
            font-weight: 600;
            font-size: 18px;
            line-height: 22px;
            color: #212541;
            margin-bottom: 15px;
        }
    }
}

.non_offer {
    align-items: center;
    display: flex;
    padding-bottom: 0 !important;
    height: 140px;
    display: grid;
    text-align: center;

    .create {
        margin: 20px auto;
    }
}

.all_offers {
    width: 100%;
    height: 104px;
    position: absolute;
    bottom: 36px;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    background: linear-gradient(0deg, #f9f9f9 0%, rgba(249, 249, 249, 0) 100%);

    a.button {
        position: absolute;
        left: 0;
        right: 0;
        bottom: -20px;
        margin: auto;
        width: 219px;
        height: 44px;
        background: #3455db;
        border-radius: 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-family: Montserrat;
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 18px;
        color: #ffffff;
    }
}

.posledne_ponuky {
    margin-top: 30px;
    font-family: Montserrat;
    font-style: normal;
    font-weight: 600;
    font-size: 18px;
    line-height: 22px;
    display: flex;
    align-items: center;
    color: #212541;
}

.pcoded-content {
    .row {
        padding: 20px;
    }
}

@media (max-width: 600px) {
    .uzivatelia_mob {
        display: block !important;
    }
}

.dash_box {
    width: 100%;
    height: 87px;
    border-radius: 6px;
    display: flex;
    align-items: center;
    padding: 21px 17px;

    &.colorP1 {
        background: #cd9c65;
    }

    &.colorP2 {
        background: #ba8e4f;
    }

    &.colorP3 {
        background: #b97f3c;
    }

    &.colorP4 {
        background: #a27035;
    }

    &.colorP5 {
        background: #6c4a23;
    }

    &.purple1 {
        background: #9fa0ff;
    }

    &.purple2 {
        background: #8e94f2;
    }

    &.purple3 {
        background: #747acf;
    }

    &.blue {
        background: #4a6d8c;
    }

    &.blue1 {
        background: #007bff;
    }

    &.blue2 {
        background: #076edc;
    }

    &.blue3 {
        background: #065cb8;
    }

    &.blue4 {
        background: #054f9e;
    }

    &.blue5 {
        background: #043e7c;
    }

    &.orange {
        background: #f93c34;

        p {
            opacity: 0.8;
        }
    }

    &.yellow {
        background: #fbbf24;

        p {
            opacity: 0.8;
        }
    }

    &.free {
        background: #455A64;
    }

    &.profi {
        background: #388E3C;
    }
    &.small_team {
        background: #2E7D32;
    }
    &.large_team {
        background: #1B5E20;
    }

    div {
        font-family: Montserrat;
        font-style: normal;

        h3 {
            font-weight: 600;
            font-size: 20px;
            line-height: 110%;
            color: #ffffff;
            margin-bottom: 7px;
        }

        p {
            font-weight: 600;
            font-size: 10px;
            line-height: 12px;
            letter-spacing: 0.1em;
            text-transform: uppercase;
            color: #ffffff;
            opacity: 0.6;
            margin: 0;
        }
    }
}

a.button {
    position: absolute;
    left: 0;
    right: 0;
    bottom: -20px;
    margin: auto;
    width: 219px;
    height: 44px;
    background: #3455db;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: Montserrat;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 18px;
    color: #ffffff;
}

$s: 3em;
$colors: #1fbcd3, #cbe2b4, #f6b6ca;

*,
*:before,
*:after {
    box-sizing: border-box;
}

@mixin cbox {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

@mixin fbox {
    @include cbox;
    width: 100%;
    height: 100%;
}

.loader_form {
    height: 150px;
    width: 150px;
    @include cbox;
}

.container_loader {
    transform-style: preserve-3d;
    perspective: 2000px;
    transform: rotateX(-30deg) rotateY(-45deg);
}

.holder_loader {
    @include cbox;
    transform-style: preserve-3d;
    transform: translate3d(0em, $s, $s * 0.5);

    &:last-child {
        transform: rotateY(-90deg) rotateX(90deg) translate3d(0, $s, $s * 0.5);
    }

    &:first-child {
        transform: rotateZ(-90deg) rotateX(-90deg) translate3d(0, $s, $s * 0.5);
    }

    @for $i from 1 through 3 {
        $color: nth($colors, $i);

        &:nth-child(#{$i}) {
            .box_loader {
                background-color: $color;

                &:before {
                    background-color: darken($color, 20);
                }

                &:after {
                    background-color: darken($color, 10);
                }
            }
        }
    }
}

.box_loader {
    @include cbox;
    transform-style: preserve-3d;
    animation: ani-box 6s infinite;
    width: $s;
    height: $s;

    //opacity: .9;
    &:before,
    &:after {
        position: absolute;
        width: 100%;
        height: 100%;
        content: "";
    }

    &:before {
        left: 100%;
        bottom: 0;
        transform: rotateY(90deg);
        transform-origin: 0 50%;
    }

    &:after {
        left: 0;
        bottom: 100%;
        transform: rotateX(90deg);
        transform-origin: 0 100%;
    }
}

@keyframes ani-box {
    8.33% {
        transform: translate3d(-50%, -50%, 0) scaleZ(2);
    }

    16.7% {
        transform: translate3d(-50%, -50%, -$s) scaleZ(1);
    }

    25% {
        transform: translate3d(-50%, -100%, -$s) scaleY(2);
    }

    33.3% {
        transform: translate3d(-50%, -150%, -$s) scaleY(1);
    }

    41.7% {
        transform: translate3d(-100%, -150%, -$s) scaleX(2);
    }

    50% {
        transform: translate3d(-150%, -150%, -$s) scaleX(1);
    }

    58.3% {
        transform: translate3d(-150%, -150%, 0) scaleZ(2);
    }

    66.7% {
        transform: translate3d(-150%, -150%, 0) scaleZ(1);
    }

    75% {
        transform: translate3d(-150%, -100%, 0) scaleY(2);
    }

    83.3% {
        transform: translate3d(-150%, -50%, 0) scaleY(1);
    }

    91.7% {
        transform: translate3d(-100%, -50%, 0) scaleX(2);
    }

    100% {
        transform: translate3d(-50%, -50%, 0) scaleX(1);
    }
}
</style>
